import { render, staticRenderFns } from "./NewsReel.vue?vue&type=template&id=3cbfa73f"
import script from "./NewsReel.vue?vue&type=script&lang=js"
export * from "./NewsReel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports